import type { FaireProductEntity } from "../../entity_types/product";

export const p_h579wqfk6d: FaireProductEntity = {
  token: "p_h579wqfk6d",
  type: "product",
  name: "High Neck Pumpkin Ghost Merrow Hem Mesh Top",
  brandToken: "b_5apqh2a958",
  brandName: "Haptics",
  imageUrl:
    "https://cdn.faire.com/fastly/96d19e33d8e5e9ebf8511f0417ef2522032440c177b18aa118fcae65ddb0f381.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/77cfe38b093168e25709405eb44383f7de9f42f1faebe8ddd7cd10fadb1c12fb.jpeg",
    "https://cdn.faire.com/fastly/25c03f4aadd7bfdb4cd9e5d0e5d1d9ffe084bc3f051793f835eca478d4c32818.jpeg",
    "https://cdn.faire.com/fastly/511caf90d9d4c72abae852d42a38d63abd05760d708ba1d1dc64da1ea35d3880.jpeg",
    "https://cdn.faire.com/fastly/57c50f3781eb2d36d0a7476f653cdea954d11973f93ea8f903681fb0522a79fb.jpeg",
  ],
  priceDollars: 75,
  description:
    "HIGH NECK LINE LONG SLEEVE HALLOWEEN PUMPKIN GHOST PRINT MESH SEMI SHEER TOP WITH FRILLED MERROW HEM",
  tags: [],
  msrpDollars: 150,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:40.817Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
